<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/ImageUpload/NewDImageUploadPreview'
export default {
  name: 'NewDSingleImagePreview',
  extends: compoment
}
</script>
